import React from 'react';
import styles from './ActionButton.module.css';

interface ActionButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  text: string;
  icon: React.ElementType; // Componente icona da lucide-react
  onClick: () => void;
  isActive?: boolean;
  activeIcon?: React.ElementType; // Icona alternativa quando isActive è true
  activeText?: string;         // Testo alternativo quando isActive è true
}

const ActionButton: React.FC<ActionButtonProps> = ({
  text,
  icon: Icon,
  onClick,
  isActive = false,
  activeIcon: ActiveIcon,
  activeText,
  className,
  ...props
}) => {
  const currentText = isActive && activeText ? activeText : text;
  const CurrentIcon = isActive && ActiveIcon ? ActiveIcon : Icon;

  const buttonClasses = [
    styles.actionButton,
    isActive ? styles.active : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type="button"
      className={buttonClasses}
      onClick={onClick}
      {...props}
    >
      <CurrentIcon size="1em" />
      <span>{currentText}</span>
    </button>
  );
};

export default ActionButton;